module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.globalMessage.message.text) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card text-xs-center z-depth-2",
    class: _vm.className
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('p', {
    staticClass: "white-text"
  }, [_vm._v(_vm._s(this.$store.state.globalMessage.message.text))])]), _vm._v(" "), _c('button', {
    staticClass: "dismissBtn",
    on: {
      "click": _vm.dismiss
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2eaa378a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2eaa378a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GlobalMessage.vue
// module id = 768
// module chunks = 3